import SettingsIcon from '@mui/icons-material/Settings'
import ApplicationCreate from './ApplicationCreate'
import ApplicationEdit from './ApplicationEdit'
import ApplicationList from './ApplicationList'
import ApplicationShow from './ApplicationShow'

export default {
  list: ApplicationList,
  create: ApplicationCreate,
  edit: ApplicationEdit,
  show: ApplicationShow,
  icon: SettingsIcon,
}
